import { useQuery } from "@tanstack/react-query";
import { getApplicantCountForJob } from "app/api/job_api";

const useGetApplicantCountForJob = (jobId, options = {}) => {
  return useQuery({
    queryKey: ["job_applicant_count", jobId],
    queryFn: () => getApplicantCountForJob(jobId),
    enabled: !!jobId,
    staleTime: 10000,
    ...options
  });
};

export default useGetApplicantCountForJob;
